import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";

import api from "../../services/api";
import Loader from "../../components/Loader";
import Table from "../../components/Table";
import Pagination from "../../components/Pagination";

const HEADER = [
  { title: "Produit", key: "buyer_plan" },
  { title: "Créer par", key: "user_first_name" },
  { title: "Date de création", key: "created_at" },
  { title: "Paiement", key: "buyer_has_paid" },
];

const List = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    search: searchParams.get("search") || "",
    page: Number(searchParams.get("page")) || 1,
    limit: Number(searchParams.get("limit")) || 100,
    sort: { created_at: -1 },
  });

  const [investors, setInvestors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let query = {};
        if (filters.search) query.search = filters.search;
        if (filters.page) query.skip = (filters.page - 1) * filters.limit;
        if (filters.limit) query.limit = filters.limit;
        if (filters.sort) query.sort = filters.sort;

        setSearchParams(filters);

        const res = await api.post("/investor/search", { buyer: true, ...query });
        if (!res.ok) throw res;
        setInvestors(res.data);
        setTotal(res.total);
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de la récupération des données");
      }
      setLoading(false);
    };

    fetchData();
  }, [filters]);

  return (
    <div className="p-8">
      <header className="w-full">
        <h1 className="text-3xl font-semibold text-black mb-2">Services d'Acquisition</h1>
      </header>
      <input
        type="text"
        placeholder="Rechercher un service"
        className="mt-3 block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
        value={filters.search}
        onChange={(event) => setFilters((prevFilters) => ({ ...prevFilters, search: event.target.value }))}
      />
      {loading ? (
        <Loader />
      ) : (
        <section className="w-full py-4 flex flex-col">
          <Table
            sort={filters.sort}
            onSort={(key) => {
              setFilters({ ...filters, sort: { [key]: filters.sort[key] === 1 ? -1 : 1 } });
            }}
            header={HEADER}
            loading={loading}
            noResultRender={<div className="w-full bg-white text-center p-2 my-5 rounded shadow-sm">Aucun résultat trouvé</div>}>
            {investors.map((e, index) => (
              <tr
                onClick={() => navigate(`/buyer-service/${e._id}`)}
                className="bg-white odd:bg-gray-50 hover:bg-gray-100 h-14 rounded-lg cursor-pointer border hover:border-gray-400"
                key={e._id}>
                <td className="p-2 max-w-xs truncate">{e.buyer_plan}</td>
                <td className="p-2 max-w-xs truncate">
                  {e.user_first_name} {e.user_last_name}
                </td>
                <td className="p-2 max-w-xs truncate">{new Date(e.created_at).toLocaleDateString("fr-FR")}</td>
                <td className="p-2 max-w-xs truncate">
                  {e.buyer_has_paid ? (
                    <span className="text-green-500 border border-green-500 bg-green-100 rounded px-2 py-1">Validée</span>
                  ) : (
                    <span className="text-orange-500 border border-orange-500 bg-orange-100 rounded px-2 py-1">Non payé</span>
                  )}
                </td>
              </tr>
            ))}
          </Table>
        </section>
      )}
      <Pagination page={filters.page} setPage={(page) => setFilters({ ...filters, page })} last={Math.ceil(total / filters.limit)} />
    </div>
  );
};

export default List;
